// The AuthenIQ Teams meeting app. One page, two modes:
//   ?mode=config — Teams' "add to meeting" flow; registers the side panel.
//   default      — the in-meeting side panel: deploy the bot, watch the room.
// Teams renders these inside its own iframe and requires the page to
// initialize the Teams JS SDK before it is considered valid.
import React, { useEffect, useState } from 'react';
import LiveTest from './LiveTest';
import { Gate, useGate } from './Landing';

const TEAMS_SDK = 'https://res.cdn.office.net/teams-js/2.19.0/js/MicrosoftTeams.min.js';
const PANEL_URL = 'https://www.autheniq.ai/teams';

function loadTeamsSdk() {
  return new Promise((resolve) => {
    if (window.microsoftTeams) return resolve(window.microsoftTeams);
    const s = document.createElement('script');
    s.src = TEAMS_SDK;
    s.onload = () => resolve(window.microsoftTeams);
    s.onerror = () => resolve(null); // outside Teams the page still works
    document.head.appendChild(s);
  });
}

export default function Teams() {
  const isConfig = new URLSearchParams(window.location.search).get('mode') === 'config';
  const { open, tryCode } = useGate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      const teams = await loadTeamsSdk();
      if (teams) {
        try {
          await teams.app.initialize();
          if (isConfig) {
            teams.pages.config.registerOnSaveHandler((event) => {
              teams.pages.config
                .setConfig({ entityId: 'autheniq-live', contentUrl: PANEL_URL, suggestedDisplayName: 'AuthenIQ' })
                .then(() => event.notifySuccess())
                .catch(() => event.notifyFailure('Could not save'));
            });
            teams.pages.config.setValidityState(true);
          }
        } catch (e) { /* not inside Teams — plain browser view */ }
      }
      setReady(true);
    })();
  }, [isConfig]);

  if (!ready) return null;

  if (isConfig) {
    return (
      <div style={{ padding: 24, fontFamily: "-apple-system, 'Segoe UI', Roboto, sans-serif" }}>
        <h2 style={{ margin: '0 0 8px' }}>AuthenIQ</h2>
        <p style={{ color: '#475569', margin: 0 }}>
          Adds a live verification panel to this meeting. Press Save to continue.
        </p>
      </div>
    );
  }

  // The side panel is the live test, gated by the same beta code as the site.
  return (
    <div className="landing" style={{ minHeight: '100vh' }}>
      {open ? <LiveTest /> : <Gate onOpen={tryCode} />}
    </div>
  );
}
